import LeftBodyCardTenis from './leftBodyCardTenis/leftBodyCartdTenis';
import RightBodyCardTenis from './rightBodyCardTenis/rightBodyCardTenis';
import './bodyCardTenis.sass';

/**
 * Representa el cuerpo central de una tarjeta de partido de tenis, divido en dos secciones:
 * izquierda con la información de los jugadores, y derecha con los momios o acciones de apuestas.
*/
export default function BodyCardTenis({ data, patrocinador, flagMomios }) {
  return(
    <div className='card-tenis__body'>
      {/* renderiza la bandera y nombre de los participantes */}
      <LeftBodyCardTenis data={data}/>

      {/* renderiza los momios y los marcadores */}
      <RightBodyCardTenis data={data} patrocinador={patrocinador} flagMomios={flagMomios} />
    </div>
  )
}